<script setup lang="ts">
    interface BackgroundVideoProps {
        src?: string;
        data: AssetInternal;
    }

    const props = defineProps<BackgroundVideoProps>();

    const videoRef = useTemplateRef<HTMLVideoElement>('video');
    const videoActive = inject(VIDEO_ACTIVE_INJECTION_KEY, ref(true));
    watch(
        () => videoActive?.value,
        (active) => {
            if (!videoRef.value) return;
            if (active) {
                videoRef.value.play().catch(() => {
                    // Handle play error, e.g., autoplay policy restrictions
                });
            } else {
                videoRef.value.pause();
            }
        },
    );

    const videoData = computed(() => {
        if (!props.data || typeof props.data === 'string' || !isAssetDataBynderVideo(props.data)) return;
        return props.data.data;
    });

    const videoSrc = computed(() => {
        const { baseUrl = '', videoPreview } = unref(videoData) || {};
        if (!videoPreview) return;
        return videoPreview.startsWith('https') ? videoPreview : `${baseUrl}${videoPreview}`;
    });

    const webm = computed(() => {
        return videoData.value?.webm;
    });
</script>

<template>
    <div class="atm-background-video absolute top-0 right-0 bottom-0 left-0 h-full w-full">
        <lazy-atm-image
            v-if="data"
            :data="data"
            class="absolute h-full w-full"
            cover />
        <video
            class="relative h-full w-full object-cover object-center"
            preload="meta"
            ref="video"
            autoplay
            loop
            muted
            playsinline>
            <source
                :src="videoSrc"
                type="video/mp4" />
            <source
                v-if="webm"
                :src="webm"
                type="video/webm" />
        </video>
    </div>
</template>
